__turbopack_context__.v({
  "button": "Link-module__jbZQXa__button",
  "disabled": "Link-module__jbZQXa__disabled",
  "external": "Link-module__jbZQXa__external",
  "inline": "Link-module__jbZQXa__inline",
  "link": "Link-module__jbZQXa__link",
  "span": "Link-module__jbZQXa__span",
  "underline": "Link-module__jbZQXa__underline",
});
